import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Transaccion } from '../../interfaces/transaccion.interface';
import { TransactionUserDTO } from '../../interfaces/transaction-user.dto';

@Component({
  selector: 'app-dialog-cambio',
  templateUrl: './dialog-cambio.component.html',
  styleUrls: ['./dialog-cambio.component.sass']
})
export class DialogCambioComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogCambioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TransactionUserDTO) {}

    onNoClick(){
      this.dialogRef.close()
    }

    get tasaConversion(): number | null {
      const t = this.data as any;
      if (!t) return null;
      const candidatos = [
        t.tn, t.tasa, t.tasaConversion, t.rate,
        t.precio_compra, t.precioCompra,
        t.valorCambio?.tasa, t.valorCambio?.tasaUsdtClp,
        t.tasaCambio?.tasa,
      ];
      for (const c of candidatos) {
        const n = +c;
        if (!isNaN(n) && n > 0) return n;
      }
      const pares: Array<[any, any]> = [
        [t.monedaOrigen, t.monedaDestino],
        [t.totalMonedaOrigen, t.totalMonedaDestino],
        [t.totalEnvio, t.totalDest],
      ];
      for (const [o, d] of pares) {
        const origen = Math.abs(+o);
        const destino = Math.abs(+d);
        if (origen && destino) {
          return origen >= destino ? origen / destino : destino / origen;
        }
      }
      const desc: string = t.comentarios || t.description || '';
      const m = desc.match(/(?:tasa|rate)[:\s]+([0-9]*\.?[0-9]+)/i);
      if (m) {
        const n = +m[1];
        if (!isNaN(n) && n > 0) return n < 1 ? 1 / n : n;
      }
      return null;
    }

    get motivoDisplay(): string {
      const motivo = this.data?.motivo || '';
      if (!motivo.toLowerCase().includes('undefined')) return motivo;
      const tasa = this.tasaConversion;
      if (tasa) {
        const formatted = tasa.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return motivo.replace(/undefined/gi, formatted);
      }
      return motivo.replace(/:\s*undefined\s*USDT/gi, '').replace(/\s*undefined\s*/gi, ' ').trim();
    }
}
